export default {
    state: {
        providerList: [],
        loadedProviderList: [],
        brandProviderListLoader: false,
        brandProviderActionCheckLoader: false,
        brandProviderListExpand: [],
        brandProviderListOptions: {
            page: 1,
            itemsPerPage: -1,
            sortBy: ['name'],
            sortDesc: [false],
            multiSort: false,
            mustSort: true,
            descending: false,

        },
    },
    actions: {
        async fetchBrandProviderList(ctx) {
            ctx.commit('updateBrandProviderListLoader', true)
            const requestParams = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                },
            };
            const res = await fetch("/api/provider/", requestParams);
            if (!res.ok) {
                this._vm.$toast.error("Error:" + res['error'], {timeout: 5000})
                return
            }
            const providerList = await res.json();
            ctx.commit('updateProviderList', providerList)
            ctx.commit('updateBrandProviderListLoader', false)
        },
        async saveBrandProviderList(ctx) {
            ctx.commit('updateBrandProviderListLoader', true)
            let csrfToken = this._vm.$readCookie('csrftoken')
            let loadedProviderSet = ListToSet(ctx.state.loadedProviderList)
            for (let provider of ctx.state.providerList) {
                let providerStringify = JSON.stringify(provider)
                if (!loadedProviderSet.has(providerStringify)) {
                    const requestParams = {
                        method: "PATCH",
                        headers: {
                            "Content-Type": "application/json",
                            'credentials': "same-origin",
                            'X-CSRFToken': csrfToken,
                        },
                        body: JSON.stringify({
                            'lead_day': provider.lead_day,
                            'cache_hours': provider.cache_hours,
                            'priority': provider.priority,
                            'scrap_enable': provider.scrap_enable,
                        })
                    };
                    const res = await fetch("/api/provider/" + provider.id + "/", requestParams);
                    if (!res.ok) {
                        this._vm.$toast.error("Error:" + res['error'], {timeout: 5000})
                    }
                }
            }
            ctx.commit('updateProviderList', ctx.state.providerList)
            ctx.commit('updateBrandProviderListLoader', false)
        },
        async fetchActionCheckProviders(ctx) {
            ctx.commit('updateBrandProviderActionCheckLoader', true)
            ctx.commit('updateBrandProviderListExpand', [])
            const requestParams = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                },
            };
            let res = await fetch("/brands/action/provider_check/", requestParams)
            if (!res.ok) {
                this._vm.$toast.error("Error:" + res['error'], {timeout: 5000})
                ctx.commit('updateBrandProviderActionCheckLoader', false)
                return
            }
            ctx.commit('updateBrandProviderActionCheckLoader', false)
            ctx.dispatch('fetchBrandProviderList')
        },
    },
    mutations: {
        updateProviderList(state, providerList) {
            state.providerList = providerList
            state.loadedProviderList = JSON.parse(JSON.stringify(providerList))
        },
        updateBrandProviderListLoader(state, brandProviderListLoader) {
            state.brandProviderListLoader = brandProviderListLoader
        },
        updateBrandProviderActionCheckLoader(state, brandProviderActionCheckLoader) {
            state.brandProviderActionCheckLoader = brandProviderActionCheckLoader
        },
        updateBrandProviderListExpand(state, brandProviderListExpand) {
            state.brandProviderListExpand = brandProviderListExpand
        }
    },
    getters: {
        getProviderList(state, getters, rootState, dispatch) {
            return state.providerList
        },
        getBrandProviderListLoader(state) {
            return state.brandProviderListLoader
        },
        getBrandProviderActionCheckLoader(state) {
            return state.brandProviderActionCheckLoader
        },
        getBrandProviderListExpand(state) {
            return state.brandProviderListExpand
        },
        getBrandProviderListOptions(state) {
            return state.brandProviderListOptions
        },
    }
}

function ListToSet(sourceList) {
    let result = new Set()
    for (const source of sourceList) {
        result.add(JSON.stringify(source))
    }
    return result
}